<template>
  <div class="address">
    <div class="address__left" :style="{ width: formItemWidth }">
      <!-- <el-select
        class="address-select"
        v-model="addressValue"
        size="medium"
        filterable
        remote
        :remote-method="handleAddressSearch"
        :loading="addressLoading"
        @change="handleAddressChange"
        placeholder="请输入地址"
      >
        <el-option
          v-for="item in addressList"
          :key="item.id"
          :label="item.description"
          :value="item.description"
        ></el-option>
      </el-select> -->
       <el-autocomplete
        class="address-select"
        v-model="addressValue"
        value-key="description"
        :fetch-suggestions="handleAddressSearch"
        size="medium"
        placeholder="请输入地址"
        popper-class="address-autocomplete"
        :trigger-on-focus="false"
        @select="handleAddressChange"
      ></el-autocomplete>
      <slot name="tip">
        <div class="address-tip">请输入地址,城市或者邮编</div>
      </slot>
      <div v-show="showCityOptions">
        <div class="address-city">
          <div class="address-city__name">所在城市</div>
          <el-select
            class="address-city__select"
            v-model="cityValue"
            size="medium"
            placeholder="请选择城市"
            @change="emitChange"
          >
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="address__right">
      <YorkbbsMap
        class="address-map"
        :width="240"
        :height="150"
        :detail-visible="detailVisible_"
        :position="{ lat: latitude_, lng: longitude_ }"
        popper-append-to-body=“false”
        @updatePosition="updateLatLng"
      ></YorkbbsMap>
     
<!--       <el-checkbox
        class="address-deatil__checkbox"
        v-show="Boolean(addressValue)"
        :false-label="0"
        :true-label="1"
        v-model="detailVisible_"
        @change="emitChange"
      >
        <span>地图上显示我的位置定位</span>
      </el-checkbox> -->
    </div>
  </div>
</template>
<script>
import { debounce } from 'throttle-debounce';
import YorkbbsMap from '@/common/google-map/google-map.vue';

export default {
  name: 'FormAddress',
  components: { YorkbbsMap },
  data() {
    return {
      cityName: '',
      // 城市列表
      cityList: [],
      // 城市加载状态
      cityLoading: false,
      // 选中的城市
      cityValue: undefined,
      // 地址列表
      addressList: [],
      // 地址加载状态
      addressLoading: false,
      // 显示城市选项
      showCityOptions: false,
      // 选中的地址
      addressValue: undefined,
      // 内部属性，是否显示详细地址
      detailVisible_: 0,
      // 内部属性，纬度
      latitude_: 0,
      // 内部属性：经度
      longitude_: 0,
    };
  },
  props: {
    // 组件宽度
    formItemWidth: {
      type: String,
      default: '280px',
    },
    // 是否显示详细地址
    detailVisible: [Number, Boolean],
    // 纬度
    latitude: Number,
    // 经度
    longitude: Number,
    // 地址
    address: String,
    // 城市
    city: String,
  },
  watch: {
    addressValue: {
      immediate: true,
      handler() {
        this.addressValue; 
        // Edward 在2024年3月8日取消显示 this.addressValue && (this.showCityOptions = true); 
      },
    },
    detailVisible: {
      immediate: true,
      handler() {
        this.detailVisible_ = Number(this.detailVisible);
      },
    },
    latitude: {
      immediate: true,
      handler() {
        this.latitude_ = this.latitude;
      },
    },
    longitude: {
      immediate: true,
      handler() {
        this.longitude_ = this.longitude;
      },
    },
    address: {
      immediate: true,
      handler() {
        this.addressValue = this.address;
      },
    },
    city: {
      immediate: true,
      handler() {
        this.cityValue = this.city;
      },
    },
  },
  computed: {
    /* 城市名称与城市id映射关系 */
    cityMap() {
      const cityList = this.cityList.slice(0);
      let map = {};
      cityList.forEach(item => {
        map[item.name] = item.id;
      });
      return map;
    },
  },
  created() {
    this.latitude_ = this.latitude;
    this.longitude_ = this.longitude;
    this.getCityList();
  },
  methods: {
    /* 获取城市列表 */
    async getCityList() {
      if (this.cityLoading) return;
      if (this.cityList.length) return;

      this.cityLoading = true;
      const { data } = await this.$axios.post('/user/v1/get/citys/gta').finally(() => {
        this.cityLoading = false;
      });

      this.cityList = data;
    },
    /* 地址搜索 */
    handleAddressSearch: debounce(800, false, async function(address,cb) {
      this.addressLoading = true;
      const { code, data } = await this.$axios.post('/gg/v1/position/autocomplete', { address }).finally(() => {
        this.addressLoading = false;
      });

      if (code === 0) {
        this.addressList = data.predictions;
        cb(this.addressList)
        if( this.addressList.length >0 ){
          this.handleAddressChange(this.addressList[0]);
        }else{
          this.longitude_=  -79.38403079999999;
          this.latitude_ = 43.65332780000001;
          this.cityValue = this.cityMap['Other GTA Area'];
          this.emitChange();
        }
      } else {
        this.addressList = [];
      }
    }),
    /* 地址发生变化 */
    async handleAddressChange(address) {
      const { data } = await this.$axios.post('/gg/v1/position/to/location', { address: address.description });
      if (data.cityName) {
        if (data.cityName == "Old Toronto") {          
          this.cityName = "Toronto";
        } else {
          this.cityName = data.cityName;
        }
        const cityId = this.cityMap[this.cityName];
        if (cityId) {
          this.cityValue = cityId;
        } else {
          this.cityValue = this.cityMap['Other GTA Area'];
        }
        this.longitude_ = data.results[0].geometry.location.lng;
        this.latitude_ = data.results[0].geometry.location.lat;
      }
      this.emitChange();
    },
    updateLatLng(val){
      console.log('接受到新的坐标信息---》',val);
      this.longitude_ = val.lng;
      this.latitude_ = val.lat
      this.emitChange();
    },
    /* 向父组件传值 */
    emitChange() {
      this.$emit('change', {
        cityId: this.cityValue,
        address: this.addressValue,
        showMyDetailAddress: this.detailVisible_,
        longitude: this.longitude_,
        latitude: this.latitude_,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.address {
  display: flex;
  justify-content: space-between;
}
.address-select {
  width: 100%;
  margin-bottom: 5px;
}
.address-tip {
  font-size: 14px;
  line-height: 17px;
  color: #999;
  margin-bottom: 12px;
}
.address-city {
  background-color: #f8f8f8;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.address-city__name {
  font-size: 14px;
  line-height: 22px;
  margin-right: 10px;
}
.address-city__select {
  width: 140px !important;
}
.address-map {
  margin-bottom: 10px;
}
.address-deatil__checkbox {
  margin: 4px 0;
  ::v-deep {
    .el-checkbox__label {
      font-size: 14px;
      line-height: 22px;
      color: #666;
    }
  }
}
::v-deep {
  .el-popper[x-placement^=bottom]{
    width: 400px !important;
  }
}
</style>
<style>
.address-autocomplete{width: 100% !important; max-width: 450px;}
</style>
